<template>
  <main class="-full-width">
    <ComponentContentRTE :rte="{ class: 'headline', text: '<h1>' + (data.page.current.title ? data.page.current.title : '') + '</h1>' }" />
    <ComponentContentRTE :rte="{ class: 'title', text: data.page.current.description ? '<h4>' + data.page.current.description + '</h4>' : '' }" />
    <ComponentContentBanner :image="imageBanner" />
  </main>
</template>

<script>
import ComponentContentBanner from '@/components/content/Banner.vue';
import ComponentContentRTE from '@/components/content/RTE.vue';
import imageBanner from '@/assets/images/header.webp';
import dataStore from '@/helpers/data';
export default {
  name: 'ViewHome',
  components: {
    ComponentContentBanner,
    ComponentContentRTE,
  },
  computed: {
    data() {
      return dataStore.getter(this.$store.getters);
    },
  },
  props: {},
  data() {
    return {
      imageBanner: imageBanner,
    };
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>